
import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { Check, CheckCheck } from 'lucide-react';
import { Message } from '@/types/chat';
import MessageContent from './MessageContent';
import { cn } from '@/lib/utils';

interface MessageBubbleProps {
  message: Message;
  isUserMessage: boolean;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message, isUserMessage }) => {
  const getStatusIcon = () => {
    if (!isUserMessage) return null;
    
    switch (message.status) {
      case 'sent':
        return <Check className="h-3 w-3 text-muted-foreground inline-block ml-1" />;
      case 'delivered':
        return <CheckCheck className="h-3 w-3 text-muted-foreground inline-block ml-1" />;
      case 'read':
        return <CheckCheck className="h-3 w-3 text-blue-500 inline-block ml-1" />;
      default:
        return null;
    }
  };

  return (
    <div className={`flex ${isUserMessage ? 'justify-end' : 'justify-start'} mb-4`}>
      <div
        className={cn(
          'max-w-[80%] p-3 rounded-lg',
          isUserMessage 
            ? 'bg-primary text-primary-foreground rounded-br-none' 
            : 'bg-muted rounded-bl-none'
        )}
      >
        <MessageContent 
          text={message.text}
          type={message.type}
          mediaUrl={message.mediaUrl}
          mediaName={message.mediaName}
          mediaDuration={message.mediaDuration}
          mediaSize={message.mediaSize}
          isUserMessage={isUserMessage}
        />
        <p className={cn(
          'text-xs mt-1',
          isUserMessage 
            ? 'text-primary-foreground/70' 
            : 'text-muted-foreground'
        )}>
          <span title={new Date(message.timestamp).toLocaleString()}>
            {formatDistanceToNow(new Date(message.timestamp), { addSuffix: true })}
          </span>
          {getStatusIcon()}
        </p>
      </div>
    </div>
  );
};

export default MessageBubble;
